module.exports = __webpack_public_path__ + "media/images/official/plan_ticket_icon3-d306dc918773feb02f0ab7aade543485.svg";